import { render, staticRenderFns } from "./LikePostButton.vue?vue&type=template&id=3e03f6d8&scoped=true"
import script from "./LikePostButton.vue?vue&type=script&lang=js"
export * from "./LikePostButton.vue?vue&type=script&lang=js"
import style0 from "./LikePostButton.vue?vue&type=style&index=0&id=3e03f6d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e03f6d8",
  null
  
)

export default component.exports